import { Navigate, useSearchParams } from "react-router-dom";
import { N3TargetPage } from "@/features/n3/pages/N3TargetPage";
import { parseMesureIdsParam } from "@/features/n3/mappers/n3-params";

/**
 * `/n3` detail route. Bare `/n3` redirects to the measures registry —
 * detail requires `?mesureIds=`.
 */
export function N3Page() {
  const [searchParams] = useSearchParams();
  const mesureIds = parseMesureIdsParam(searchParams.get("mesureIds"));

  if (mesureIds.length === 0) {
    return <Navigate to="/measures" replace />;
  }

  return <N3TargetPage mesureIds={mesureIds} />;
}
